import React, { use, useState } from 'react';
import { Button, Popconfirm, Space, Table, TableColumnsType, Tag } from 'antd';
import { useRequest } from 'ahooks';
import dayjs from 'dayjs';
import {
  AiModelListVo,
  getModelList,
  ModelProviderVo,
  updateModelConfigProvider,
  updateModelStatus,
} from '@/api/model';
import { useUpdate } from '@/common/hook';
import EditProvider from './editModal';
import { deleteUser, getUserList, UserVo } from '@/api/user';
import EditUser from './editModal';
import { PlusOutlined } from '@ant-design/icons';

const columns: TableColumnsType<UserVo> = [
  { title: '姓名 ', dataIndex: 'name', key: 'name' },
  { title: '账号', dataIndex: 'username', key: 'username' },
  {
    title: '创建时间',
    dataIndex: 'createTime',
    key: 'createTime',
    render: text => dayjs(text).format('YYYY-MM-DD HH:mm:ss'),
  },
];

const UserList = () => {
  const [editData, setEditData] = useState<UserVo>();
  const [visible, setVisible] = useState<boolean>(false);
  const [update, updateFn] = useUpdate();

  const { data: userList, loading } = useRequest(getUserList, { refreshDeps: [update] });

  const onDelete = (id: number) => {
    deleteUser(id).then(updateFn);
  };

  const buildColumns = [
    ...columns,
    {
      title: '操作',
      key: 'operation',
      render: (_: any, record: UserVo) => (
        <Space size={8}>
          <Button
            type="link"
            size="small"
            style={{ padding: 0 }}
            onClick={() => {
              setEditData(record);
              setVisible(true);
            }}
          >
            编辑
          </Button>
          <Popconfirm title="确定删除该用户？" onConfirm={() => onDelete(record.id!)}>
            <Button type="link" size="small" style={{ padding: 0 }}>
              删除
            </Button>
          </Popconfirm>
        </Space>
      ),
    },
  ];

  return (
    <>
      <Button type="primary" style={{ marginBottom: 10 }} icon={<PlusOutlined />} onClick={() => setVisible(true)}>
        新增用户
      </Button>
      <Table<UserVo> columns={buildColumns} dataSource={userList ?? []} loading={loading} />
      {visible && (
        <EditUser
          data={editData}
          isEdit={!!editData}
          updateFn={updateFn}
          onCancel={() => {
            setVisible(false);
            setEditData(undefined);
          }}
        />
      )}
    </>
  );
};

export default UserList;
